'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';

import characteristic from '../characteristic/characteristic.component';

export class CharacteristicDashboardController {

  addWindow: Function;

  data;
  model;

  characteristicOptions;
  characteristicSelected;
  characteristicGrid;

  /*@ngInject*/
  constructor($scope, $rootScope, Storage, WindowService, $q, AlertMessageFactory) {
    this.Storage  = Storage;
    this.scope    = $scope;
    this.Promise  = $q.defer;

    this.addWindow       = WindowService.addItem;

    this.error    = AlertMessageFactory.error;
    this.success  = AlertMessageFactory.success;

    $rootScope.$on('storage.save.characteristic', (characteristic) => this.updateCharacteristics());

    this.scope.characteristicForm = this.characteristicForm.bind(this);
  }

  $onInit() {

    this.Storage.onUpdate('characteristic', (characteristic, event) => {
      this.updateCharacteristics();
    });

    this.data.onCategoryChange = () => this.updateCharacteristics();

    this.characteristicOptions = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      rowEditWaitInterval: -1,
      data: [],
      onRegisterApi: (gridApi) => {
        this.characteristicGrid = gridApi;

        this.characteristicGrid.selection.on.rowSelectionChanged(this.scope, (row) => {
          this.characteristicSelected = undefined;

          if(row.isSelected){
            this.characteristicSelected = row.entity;
          }
        });
        
        this.characteristicGrid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          
          if(oldValue  == newValue) {
            return false;
          }

          return this.Storage.saveCharacteristic(rowEntity)
            .then(() => {
              this.characteristicGrid.rowEdit.setRowsClean([rowEntity]);
              this.updateCharacteristics();
            });
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        groupable: false,
        resizable: false,
        sortable: false,
        visible: false,
        width: 50
      }, {
        displayName: 'Наименование',
        field: 'name',
        groupable: false,
        resizable: true,
        sortable: true,
        visible: true,
        width: 300
      }, {
        displayName: 'Ед.Изм',
        field: 'em',
        groupable: false,
        resizable: true,
        sortable: true,
        visible: true,
      }, {
        displayName: 'Абревиатура',
        field: 'abbreviation',
      }, {
        displayName: 'Категория',
        field: 'categoryId',
        groupable: true,
        resizable: true,
        sortable: true,
        visible: true,
        width: 200,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCategory"></div>',
        editableCellTemplate: 'ui-grid/dropdownEditor',
        editDropdownValueLabel: 'name',
        //editDropdownOptionsArray: this.buildCategorOptions(this.categories),
      }, {
        displayName: '#',
        name: ' ',
        cellTemplate: '<div><button ng-click="grid.appScope.characteristicForm(row.entity);$event.stopPropagation();""><i class="fa fa-pencil"></i></button></div>'
      }]
    };
  }

  buildCategorOptions(categories) {
    return categories.map(c => {
      var pad = '';
      for(var i = 0; i < c.realLelev; i++){
        pad += String.fromCharCode(160) + String.fromCharCode(160);
      }

      return {
        id: c._id,
        name: pad + c.name
      };
    });
  }

  updateCharacteristics() {
    while(this.characteristicOptions.data.length > 0){
      this.characteristicOptions.data.shift();
    }

    this.Storage.getCharacteristics()
      .filter(characteristic => (this.data.categorySelected ? this.data.categorySelected._id : undefined) == characteristic.categoryId)
      .forEach(characteristic => this.characteristicOptions.data.push(characteristic));
  }

  characteristicForm(characteristic) {
    this.addWindow({
      id: 'create-characteristic-window',
      component: 'characteristic',
      title: 'Форма редактирования',
      width: 700,
      height: 530,
      characteristic: characteristic,
      category: this.data.categorySelected,
      module: this.data.module,
    });
  }
}



export default angular.module('storageApp.characteristic-dashboard', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    characteristic,
  ])
  .component('characteristicDashboard', {
    bindings: {data: '='},
    template: require('./characteristic-dashboard.html'),
    transclude: true,
    controller: CharacteristicDashboardController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/characteristic-dashboard/characteristic-dashboard.component.js